export const sizes = {
  sizes: {
    xxxsm: '0.25rem', // 4px
    xxsm: '0.5rem', // 8px
    xsm: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    lg: '1rem', // 16px
    xlg: '1.25rem', // 20px
    xxlg: '1.5rem', // 24px
    xxxlg: '2rem', // 32px
  },
  space: {
    xxxsm: '0.25rem', // 4px
    xxsm: '0.5rem', // 8px
    xsm: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    lg: '1rem', // 16px
    xlg: '1.25rem', // 20px
    xxlg: '1.5rem', // 24px
    xxxlg: '2rem', // 32px
  },
  fontSizes: {
    xxsm: '0.625rem', // 10px
    xsm: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    md: '1rem', // 16px
    lg: '1.125rem', // 18px
    xlg: '1.25rem', // 20px
    xxlg: '1.5rem', // 24px
    xxxlg: '2rem', // 32px
  },
  fontWeights: {
    n: 400,
    md: 600,
    lg: 700,
  },
  lineHeights: {
    sm: '100%',
    md: '120%',
    lg: '140%',
    xlg: '150%',
  },
  radii: {
    xxsm: '2px',
    xsm: '4px',
    sm: '8px',
    md: '12px',
    lg: '14px',
    xlg: '16px',
    full: '9999px'
  }
}
